import { CardActionArea, CardContent, Tooltip } from '@mui/material';
import Image from 'next/image';
import { GroupsIcon } from '../../constant/imgImport';
import { checkNullish } from '../../helpers/checkNullish';
import { IFolderPreview } from '../../interfaces/components/card.interface';
const FolderPreview = ({
  classname,
  folderName,
  capacity: _capacity,
  handleClick,
  handleSeeMore,
  isDeleted,
  dateLeft,
  handleContextMenu,
  numOfMember,
  avatar,
}: IFolderPreview) => {
  return (
    <div
      onClick={() => {
        handleClick();
      }}
      onContextMenu={() => {
        handleContextMenu();
      }}
      className={`flex h-16 w-full items-center gap-2 overflow-hidden truncate rounded-md bg-white ${classname} `}
    >
      <CardActionArea className="w-full border-collapse bg-transparent hover:bg-[#ecf5f9]">
        <CardContent className="flex items-center justify-between text-sm ">
          <div className="flex items-center gap-3 overflow-x-hidden pr-2">
            <div
              className={`flex shrink-0 items-center ${
                avatar ? 'overflow-hidden rounded-full' : ''
              }`}
            >
              <Image
                alt="group icon"
                src={avatar || GroupsIcon}
                width={40}
                height={40}
                objectFit={'cover'}
              />
            </div>
            <div className="flex flex-col truncate">
              <Tooltip title={folderName}>
                <p className="truncate text-base font-medium">{folderName}</p>
              </Tooltip>
              <div className="flex items-center justify-between">
                <p className="text-xs ">{numOfMember ?? 1} người </p>
                {checkNullish(dateLeft) && (
                  <p className="absolute right-2 text-xs text-gray-400">
                    {dateLeft} ngày
                  </p>
                )}
              </div>
            </div>
          </div>

          {!isDeleted && handleSeeMore && (
            <div
              className="mt-auto shrink-0 cursor-pointer py-1 lg:hidden"
              onClick={(e) => {
                e.stopPropagation();
                handleSeeMore();
              }}
            >
              <Image src="/icons/3-dots-vertical.svg" width={30} height={30} />
            </div>
          )}
        </CardContent>
      </CardActionArea>
    </div>
  );
};

export default FolderPreview;
